export default {
  headerContent: {
    title: 'Sompo Sigorta Konut (Ev) Sigortası Fiyatları',
    slogan: "Konut Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'KONUT SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Sompo Sigorta Konut Sigortası',
    description: {
      title: 'Sompo Sigorta Konut Sigortası (Ev Sigortası) Nedir? ',
      content: [
        'Sompo Sigorta konut sigortası ile sigortalılarına konutlarında oluşacak hasarlara karşı güvence sunmaktadır.',
        'Sompo Sigortası konut sigortası, konutta oluşabilecek yangın, hırsızlık, sel ve su baskını gibi hasarlar sonucunda ortaya çıkan maddi kayıplara karşı koruma sağlamaktadır.'
      ]
    },
    subContent: {
      title: 'Sompo Sigorta Konut Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph: '<strong>Ana teminatlar:</strong>',
          subList: [
            '7/24 yardım hizmetleri',
            'Cam kırılması',
            'Enkaz kaldırma masrafları',
            'Hırsızlık',
            'Hırsızlık',
            'İkametgâh değişikliği masrafları',
            'İzolasyon Eksikliği',
            'Kira kaybı',
            'Yangın, yıldırım, infilak',
            'Yeni değer teminatı'
          ]
        },
        {
          paragraph: '<strong>Ek teminatlar:</strong>',
          subList: [
            'Acil Sağlık',
            'Ağaç Devrilmesi',
            'Boru kırılması',
            'Çalışanların Emniyeti Suiistimali',
            'Çevreye Ait Peyzaj',
            'Dahili su',
            'Değerli Eşya Hırsızlık',
            'Dekorasyon',
            'Deniz Taşıtları Çarpması',
            'Deprem Bina/Eşya',
            'Dolu',
            'Duman',
            'Elektrik Hasarlarına Bağlı Gıda Bozulması',
            'Elektronik Cihaz',
            'Ferdi kaza (Vefat / sürekli sakatlık )',
            'Fırtına',
            'Grev, lokavt, kargaşa, halk hareketleri, kötü niyetli hareketler, terör',
            'Hava taşıtları çarpması',
            'Hukuksal Koruma ',
            'Kar ağırlığı',
            'Kazan / Jeneratör / Elektrik Motoru (Makine Kırılması)',
            'Kazı Sonucu Yer Kayması',
            'Kişisel 3. Şahıs Sorumluluk',
            'Misafir eşyaları',
            'Nakil Halindeki Ev Eşyası',
            'Sel-su baskını',
            'Yakıt sızması',
            'Yer kayması'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Konut Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Konut Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Konut Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Sompo Sigorta Konut Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
